var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMsgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.406,
    height: 30.406,
    viewBox: "0 0 30.406 30.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Cancel_icon",
    "data-name": "Cancel icon",
    d: "M121,112v18m9-9H112",
    transform: "translate(-155.917 15.203) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMsgCancelIcon);
export default __webpack_public_path__ + "static/media/new-msg-cancel-icon.6790b9fc0b76f9f0d8e273677eedf7a6.svg";
export { ForwardRef as ReactComponent };